import CountrySelectorMenu from './CountrySelectorMenu';
import './styles.scss';
import HeaderButton from '../HeaderButton';
import React from 'react';

const CountrySelector = () => {
    const [isOpen, setOpen] = React.useState(false);

    const onToggleMenu = () => setOpen(!isOpen);

    return (
        <div className="country-selector-container">
            <HeaderButton iconName="globe" text="Change country" onClick={onToggleMenu} />
            {isOpen && <CountrySelectorMenu onClose={onToggleMenu} />}
        </div>
    );
};

export default CountrySelector;
